/*
 * @message:
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-09-11 15:29:22
 * @FilePath: \mrc-ess-fronted\src\components\confirm\src\index.js
 * @最后编辑: Betway
 * @最后修改时间: 2021-09-03 13:33:58
 */
import Vue from "vue";
import confirmVue from "@/components/confirm/src/confirm.vue";
const defaults = {
  show: false,
  title: "",
  text: "",
  button: [],
};
let confirmVueLoading;
const confirmVueConstructor = Vue.extend(confirmVue);
confirmVueConstructor.prototype.close = function() {
  var vm = this;
  confirmVueLoading = null;
  var promise = new Promise(function(resolve, reject) {
    if (vm.$el && vm.$el.parentNode) {
      vm.$el.parentNode.removeChild(vm.$el);
    }
    resolve();
    vm.$destroy();
    vm.show = false;
  });
  return promise;
};
const confirmBox = (options = {}) => {
  options = Object.assign({}, defaults, options);
  let parent = document.body;
  if (confirmVueLoading) {
    return confirmVueLoading;
  }
  let instance = new confirmVueConstructor({
    el: document.createElement("div"),
    data: options,
  });

  parent.appendChild(instance.$el);
  Vue.nextTick(() => {
    instance.show = true;
  });
  confirmVueLoading = instance;
  return instance;
};

export default confirmBox;
